import MainContent from "../components/MainContent";

const LandingPage1 = () => {
    return ( 
        <>
            <MainContent/>
        </>
     );
}
 
export default LandingPage1;